import { baseQueryWithAuthWithoutAutoLogout } from "api/base-query";
import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { propertyTeaserApi } from "api/property-teaser";

export const performanceReportApi = createApi({
  reducerPath: 'performanceReportApi',
  baseQuery: baseQueryWithAuthWithoutAutoLogout,
  endpoints: (builder) => ({
    authorize: builder.mutation<{ unlocked: boolean }, { password: string, propertyId: string }>({
      query: ({ password, propertyId }) => ({
        method: 'POST',
        url: `propertyTeaser/${propertyId}/performanceReport/unlock`,
        body: {
          password,
        },
      }),
      async onQueryStarted({ propertyId }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          // the unlock cookie set by this request changes what GET propertyTeaser/{id}
          // returns, so the cached property (fetched before unlock) must be refetched
          if (data.unlocked) {
            dispatch(propertyTeaserApi.util.invalidateTags([{ type: 'Property', id: propertyId }]));
          }
        } catch {
          // wrong password, nothing to invalidate
        }
      },
    }),
    downloadReportFile: builder.mutation<any, { password: string; propertyId: string; documentId: string; name: string }>({
      query: ({ password, propertyId, documentId, name }) => ({
        method: 'POST',
        url: `propertyTeaser/${propertyId}/performanceReport/document/${documentId}`,
        body: {
          password,
        },
        cache: "no-cache",
        responseHandler: async (response) => {

          const fileBlob = await response.blob();
          const a = document.createElement('a');
          a.download = name;
          a.href = window.URL.createObjectURL(fileBlob);
          a.click();
          a.remove();

          return { data: null }
        }
      }),
    }),
  }),
});

export const { useAuthorizeMutation, useDownloadReportFileMutation } = performanceReportApi;